import { jwtDecode } from 'jwt-decode';

export interface JwtParts<T> {
  header: Record<string, unknown>;
  payload: T;
}

/**
 * Decode a JWT and return its parts.
 *
 * Replacement for `userManager._joseUtil.parseJwt(...)` which was a private
 * internal in `oidc-client@1.11.x` and is removed in `oidc-client-ts@3.x`.
 *
 * Only decodes (no signature verification), matching the existing call
 * sites in this codebase: `validateJwt` was never invoked.
 */
export function parseAccessToken<T = Record<string, unknown>>(
  jwt: string
): JwtParts<T> {
  // jwt-decode v4 exposes only the payload; the `header` field is unused by
  // every consumer in this codebase (all callers read `.payload` only).
  return {
    header: {} as Record<string, unknown>,
    payload: jwtDecode<T>(jwt),
  };
}
